<template>
  <div class="m-waterfall-wrap">
    <waterfall
      :col="columnCount"
      :data="imageData"
      :width="itemWidth" 
      :gutterWidth="gutterWidth"
      @scroll="scroll"
      @finish="loadFinish"
    >
      <template>
        <div class="u-item items" v-for="(item,index) in imageData" :key="index" @click="toDetails(item.id)">
          <div class="u-imgBox">
            <img class="u-img" :src="item.cover_img || defaultImg" :alt="item.title" :title="item.title" @error="imgError(item)">
          </div>
          <div class="marsk flex end">
            <div class="u-info">
              <div class="title txt-el" :title="item.title">{{ item.title }}</div>
              <div class="subs flex">
                <span class="txt-el">{{ item.organizer }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </waterfall>

  </div>
</template>
<script>
import defaultImg from '@/assets/images/defaultImg.png';
import utils from "@/utils"
export default {
  props: {
    imageData: Array,
    columnCount: { // 瀑布流要划分的列数
      type: Number,
      default: 3
    },
    gutterWidth: { // 瀑布流各列之间的间隙
      type: Number,
      default: 20
    },
    itemWidth: { // 瀑布流列宽
      type: Number,
      default: 356.5
    },
  },
  data () {
    return {
      bottomHeight: 0,
      isLoaded: false,
      defaultImg,
    }
  },
  filters: {
    date(val) {
      return utils.formatDates(val)
    },
  },
  mounted () {
    this.initPage()
  },
  methods: {
    initPage() {
      const bottomHeightList = document.getElementsByClassName('footer') || []
      const bottomHeightObj = bottomHeightList[0] || {}
      this.bottomHeight = bottomHeightObj.clientHeight || 0
    },
    scroll(scrollData){
      if(scrollData.scrollTop + scrollData.clientHeight >= scrollData.scrollHeight - this.bottomHeight && this.isLoaded){
        this.isLoaded = false
        this.$emit("loadMore")
      }
    },
    loadFinish(e) {
      this.isLoaded = true
    },
    toDetails(id) {
      this.$emit('toDetails', id)
    },
  }
}
</script>
<style scoped lang="scss">
.m-waterfall-wrap {
  .u-item {
    position: relative;
    margin-bottom: 20px;
    transition: all 0.3s;
    cursor: pointer;
    .u-imgBox {
      position: relative;
      z-index: 3;
      overflow: hidden;
      box-sizing: border-box;
      .u-img {
        width: 100%;
        height: 100%;
        transition: all 0.3s;
      }
    }
  }
}
</style>